import React, { useContext } from 'react'
import { array, func, number, shape, string } from 'prop-types'
import { DrawerContext, Drawer, DRAWER_TYPES } from 'shared/ui'
import {
  Steps,
  Proposal,
  Feed,
  CreditAnalysisDetail,
  CreditPaymentDetail,
} from './components'
import { Content, Name } from './components/Lead.styles'

const propTypes = {
  mountName: func,
  lead: shape({
    borrower: shape({
      cpf: string,
      fullName: string,
    }),
    conditions: shape({
      createdAt: string,
      instalment: shape({
        term: number,
      }),
    }),
    feeds: array,
    intendedCredit: shape({
      amount: number,
      currency: string,
    }),
    productType: string,
    steps: array,
  }),
}

const Lead = ({ mountName, lead, feed }) => {
  const { closeDrawer, drawers } = useContext(DrawerContext)

  return (
    <>
      <Content>
        <Name data-testid="lead-name" variant="h3">
          {lead && mountName(lead)}
        </Name>
        {feed?.feedItems?.length > 0 ? (
          <Feed {...feed} product={lead?.productType} />
        ) : null}
        <Proposal
          proposal={{
            borrower: lead?.borrower,
            intendedCredit: lead?.intendedCredit,
            conditions: lead?.conditions,
            creditAnalysis: lead?.creditAnalysis,
            creditPayment: lead?.payment,
          }}
          product={lead?.productType}
        />
      </Content>
      <Steps steps={lead?.steps} product={lead?.productType} />
      <Drawer
        open={drawers.CREDIT_ANALYSIS.open}
        onClose={() => closeDrawer(DRAWER_TYPES.CREDIT_ANALYSIS)}
      >
        <CreditAnalysisDetail
          creditAnalysisDetail={{
            creditAnalysis: lead?.creditAnalysis,
            intendedCredit: lead?.intendedCredit,
          }}
          product={lead?.productType}
        />
      </Drawer>
      <Drawer
        open={drawers.CREDIT_PAYMENT.open}
        onClose={() => closeDrawer(DRAWER_TYPES.CREDIT_PAYMENT)}
      >
        <CreditPaymentDetail
          creditPayment={lead?.payment}
          product={lead?.productType}
        />
      </Drawer>
    </>
  )
}

Lead.propTypes = propTypes

export { Lead }
